(ns dashboard.views.settings.users
  (:require
   [reagent.core :as reagent]
   [clojure.string :refer [split lower-case blank?]]
   [re-frame.core :as re-frame]
   [breaking-point.core :as bp]
   [headlessui-reagent.core :as ui]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.utils :refer [listen cs index-by]]
   [dashboard.events.users :as user-events]
   [dashboard.components.inputs :refer [input]]
   [dashboard.components.drawer :refer [drawer]]
   [dashboard.components.switch :refer [switch]]
   [dashboard.components.button :refer [button]]
   [dashboard.components.select :refer [select space-select]]
   [dashboard.components.profile :refer [profile-img display-user-fullname]]
   ["@heroicons/react/solid" :refer
    [SearchIcon FilterIcon ChevronLeftIcon MailIcon PhoneIcon PlusIcon]]))

(defn- user-drawer-content [{:keys [state]}]
  [:div.relative.mt-6.flex-1

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      "First Name"]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "first-name"
       :name "first-name"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:user :firstName])
       :on-change #(swap! state assoc-in [:user :firstName] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      "Last Name"]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "last-name"
       :name "last-name"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:user :lastName])
       :on-change #(swap! state assoc-in [:user :lastName] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      "名"]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "first-name-jp"
       :name "first-name-jp"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:user :firstNameJp])
       :on-change #(swap! state assoc-in [:user :firstNameJp] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      "姓"]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "last-name-jp"
       :name "last-name-jp"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:user :lastNameJp])
       :on-change #(swap! state assoc-in [:user :lastNameJp] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :user/external-id)]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "title"
       :name "title"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:user :externalId])
       :on-change #(swap! state assoc-in [:user :externalId] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :user/title)]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "title"
       :name "title"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:user :titleId])
       :on-change #(swap! state assoc-in [:user :titleId] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-1
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :user/space)]]
    [:div.sm:col-span-3
     [space-select
      {:selected (get (listen ::subs/spaces-by-id) (get-in @state [:user :spaceId]))
       :on-change #(swap! state assoc-in [:user :spaceId] (str %))}]]]

   (when (= (:id (listen ::subs/user-role)) "admin")
     [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-1
      [:div
       [:label.block.text-xs.font-medium.text-gray-900.sm:mt-px.sm:pt-2
        (tr :user/role)]]
      [:div.sm:col-span-3
       [select
        {:disabled? (= (:action @state) :view)
         :selected (get (listen ::subs/roles-by-id) (get-in @state [:user :roleId]))
         :items-list (listen ::subs/roles)
         :on-change #(swap! state assoc-in [:user :roleId] %)}]]])

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-1
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :user/isTemporary)]]
    [:div.sm:col-span-3
     [switch
      {:name "name"
       :checked? (get-in @state [:user :isTemporary])
       :on-change #(swap! state assoc-in [:user :isTemporary]
                          (not (get-in @state [:user :isTemporary])))}]]]

   [:div.flex.flex-shrink-0.justify-end.py-4
    [button
     {:on-click #(do
                   (re-frame/dispatch
                    (case (:action @state)
                      :add [::user-events/create-user {:user (:user @state)}]
                      :delete [::user-events/delete-user {:user (:user @state)}]
                      :edit [::user-events/update-user {:user (:user @state)}]
                      ""))
                   (reset! state {:is-open? false
                                  :user nil
                                  :action nil}))}
     (case (:action @state)
       :add (tr :action/create)
       :delete (tr :action/delete)
       :edit (tr :action/save)
       "")]]])

(defn content []
  (reagent/with-let
    [input-string (reagent/atom "")
     selected-staff (reagent/atom
                     (->> (listen ::subs/available-staffs)
                          (sort-by :lastName)
                          (first)))
     !drawer-state (reagent/atom {:is-open? false
                                  :user nil
                                  :action nil})]
    (fn []
      (let [;; If the selected session change, we reload
            _ (add-watch (re-frame/subscribe [::subs/available-staffs])
                         ::available-staffs-watcher
                         (fn [key atom old-state new-state]
                           (reset! selected-staff (->> new-state
                                                       (filter #(= (:id %) (:id @selected-staff)))
                                                       (first)))))
            staffs (->> (listen ::subs/available-staffs)
                        (filter #(or
                                  (when (some? (:firstName %))
                                    (>= (.indexOf
                                         (.toLowerCase (:firstName %))
                                         (.toLowerCase @input-string))
                                        0))
                                  (when (some? (:lastName %))
                                    (>= (.indexOf
                                         (.toLowerCase (:lastName %))
                                         (.toLowerCase @input-string))
                                        0))
                                  (when (some? (:lastNameJp %))
                                    (>= (.indexOf
                                         (:lastNameJp %)
                                         @input-string)
                                        0))
                                  (when (some? (:firstNameJp %))
                                    (>= (.indexOf
                                         (:firstNameJp %)
                                         @input-string)
                                        0))))
                        (sort-by :lastName))
            default-user {:organizationId (:id (listen ::subs/organization))
                          :auth0UserId "none"
                          :firstName ""
                          :lastName ""
                          :firstNameJp ""
                          :lastNameJp ""
                          :titleId ""
                          :roleId "store-staff"
                          :locale :ja
                          :spokenLanguages []                          }
            report (get (listen ::subs/staffs-by-id) (:reportToId @selected-staff))
            space  (get (listen ::subs/spaces-by-id) (:spaceId @selected-staff))
            teams-by-id (index-by (:teams space) :id)]
        [:div.flex-1.relative.z-0.flex.overflow-hidden
         [drawer
          {:state !drawer-state
           :title (case (:action @!drawer-state)
                    :add (tr :action/add-fn (tr :user))
                    :delete (tr :action/delete-fn (tr :user))
                    :edit (tr :action/edit-fn (tr :user))
                    "")
           :content [user-drawer-content
                     {:state !drawer-state}]}]
         [:main.flex-1.relative.z-0.overflow-y-auto.focus:outline-none.xl:order-last.mb-6
          [:nav.flex.items-start.px-4.py-3.sm:px-6.lg:px-8.xl:hidden
           [:a.inline-flex.items-center.space-x-3.text-sm.font-medium.text-gray-900
            [:> ChevronLeftIcon
             {:class "-ml-2 h-5 w-5 text-gray-400"
              :aria-hidden true}]
            [:span
             (tr :directory)]]]
          [:article
           ;; Profile Header
           [:div
            [:div
             [:img.h-24.w-full.object-cover.lg:h-32.bg-primary
              {:alt ""}]]
            [:div.max-w-5xl.mx-auto.px-4.sm:px-6.lg:px-8
             [:div.-mt-12.sm:-mt-16.sm:flex.sm:items-end.sm:space-x-5
              [:div.flex
               [profile-img
                {:class "h-24 w-24 ring-4 ring-white sm:h-32 sm:w-32 text-3xl"
                 :text (if (blank? (:lastNameJp @selected-staff))
                         (str (first (:firstName @selected-staff))
                              (first (:lastName @selected-staff)))
                         (:lastNameJp @selected-staff))
                 :src (:profile_picture_url @selected-staff)
                 :alt (:name @selected-staff)}]]

              [:div.mt-6.sm:flex-1.sm:min-w-0.sm:flex.sm:items-center.sm:justify-end.sm:space-x-6.sm:pb-1
               [:div.sm:hidden.mt-6.min-w-0.flex-1
                [:h1
                 [:span.font-bold.text-gray-900.truncate.text-2xl
                  (str (:firstName @selected-staff) " " (:lastName @selected-staff))]
                 [:span.ml-2.text-gray-700.truncate.text-xl
                  (str (:lastNameJp @selected-staff) " " (:firstNameJp @selected-staff))]]]

               [:div.mt-6.flex.flex-col.justify-stretch.space-y-3.sm:flex-row.sm:space-y-0.sm:space-x-4
                [:a.inline-flex.justify-center.px-4.py-2.border.border-gray-300.shadow-sm.text-sm.font-medium.rounded-md.text-gray-700.bg-white.hover:bg-gray-50.focus:outline-none.focus:ring-2.focus:ring-offset-2.focus:ring-primary-500.whitespace-nowrap
                 {:type "button"
                  :disabled (nil? (:email @selected-staff))
                  :href (str "mailto:" (:email @selected-staff))}
                 [:> MailIcon
                  {:class "-ml-1 mr-2 h-5 w-5 text-gray-400"
                   :aria-hidden true}]
                 [:span
                  (tr :action/message)]]
                [:button.inline-flex.justify-center.px-4.py-2.border.border-gray-300.shadow-sm.text-sm.font-medium.rounded-md.text-gray-700.bg-white.hover:bg-gray-50.focus:outline-none.focus:ring-2.focus:ring-offset-2.focus:ring-primary-500.whitespace-nowrap
                 {:type "button"
                  :on-click #(reset! !drawer-state {:is-open? true
                                                    :user @selected-staff
                                                    :action :edit})}
                 (tr :action/edit)]
                [:button.inline-flex.justify-center.px-4.py-2.border.border-gray-300.shadow-sm.text-sm.font-medium.rounded-md.text-gray-700.bg-white.hover:bg-gray-50.focus:outline-none.focus:ring-2.focus:ring-offset-2.focus:ring-primary-500.whitespace-nowrap
                 {:type "button"
                  :on-click #(reset! !drawer-state {:is-open? true
                                                    :user @selected-staff
                                                    :action :delete})}
                 (tr :action/delete)]]]]
             [:div.hidden.sm:block.mt-6.min-w-0.flex-1
              [:h1
               [:span.text-2xl.font-bold.text-gray-900.truncate
                (str (:firstName @selected-staff) " " (:lastName @selected-staff))]
               [:span.ml-2.text-gray-700.truncate.text-xl
                (str (:lastNameJp @selected-staff) " " (:firstNameJp @selected-staff))]
               [:span.ml-2.text-gray-700
                (:name (get (listen ::subs/roles-by-id) (:roleId @selected-staff)))]]]]]

           ;; Description
           [:div.mt-6.max-w-5xl.mx-auto.px-4.sm:px-6.lg:px-8
            [:dl.grid.grid-cols-1.gap-x-4.gap-y-8.sm:grid-cols-2
             [:div.m:col-span-1
              [:dt.text-sm.font-medium.text-gray-500
               (tr :user/title)]
              [:dd.mt-1.text-sm.text-gray-900.h-4
               (:titleId @selected-staff)]]
             [:div.m:col-span-1
              [:dt.text-sm.font-medium.text-gray-500
               (tr :user/external-id)]
              [:dd.mt-1.text-sm.text-gray-900.h-4
               (:externalId @selected-staff)]]
             [:div.m:col-span-1
              [:dt.text-sm.font-medium.text-gray-500
               (tr :user/space)]
              [:dd.mt-1.text-sm.text-gray-900.h-4
               (if (= (listen ::subs/locale) :ja)
                 (:nameJp space)
                 (:name space))]]
             [:div.m:col-span-1
              [:dt.text-sm.font-medium.text-gray-500
               (tr :user/reportTo)]
              [:dd.mt-1.text-sm.text-gray-900.h-4
               (display-user-fullname report)]]
             [:div.m:col-span-1
              [:dt.text-sm.font-medium.text-gray-500
               (tr :user/team)]
              [:dd.mt-1.text-sm.text-gray-900.h-4
               (:name (get teams-by-id (:teamId @selected-staff)))]]
             [:div.m:col-span-1
              [:dt.text-sm.font-medium.text-gray-500
               (tr :user/isTemporary)]
              [:dd.mt-1.text-sm.text-gray-900.h-4.capitalize
               (if (:isTemporary @selected-staff)
                 (tr :yes)
                 (tr :no))]]]]]]

         [:aside.hidden.xl:order-first.xl:flex.xl:flex-col.flex-shrink-0.w-84.border-r.border-gray-200
          [:div.px-6.pt-6.pb-4
           [:h2.text-lg.font-medium.text-gray-900.flex
            [:span.flex-1
             (tr :directory)]

            (when (= (:id (listen ::subs/user-role)) "admin")
              [:span
               [button
                {:small? true
                 :on-click #(reset! !drawer-state {:is-open? true
                                                   :user default-user
                                                   :action :add})}
                [:span
                 [:> PlusIcon
                  {:class "h-5 w-5"
                   :aria-hidden true}]]]])]
           [:p.mt-1.text-sm.text-gray-600
            (str "Search directory of " (listen ::subs/available-staffs-count) " staffs")]
           [:div.mt-6.flex.space-x-4
            {:action "#"}
            [:div.flex-1.min-w-0
             [:label.sr-only
              {:htmlFor "search"}
              (tr :action/search)]
             [:div.relative.rounded-md.shadow-sm
              [:div.absolute.inset-y-0.left-0.pl-3.flex.items-center.pointer-events-none
               [:> SearchIcon
                {:class "h-5 w-5 text-gray-400"
                 :aria-hidden true}]]
              [:input.focus:ring-primary-500.focus:border-primary-500.block.w-full.pl-10.sm:text-sm.border-gray-300.rounded-md
               {:type "search"
                :name "search"
                :id "search"
                :autoComplete "off"
                :value @input-string
                :on-change #(reset! input-string (-> % .-target .-value))
                :placeholder (tr :action/search)}]]]
            #_[:button
               {:type "button"
                :class "inline-flex justify-center px-3.5 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"}
               [:> FilterIcon
                {:class "h-5 w-5 text-gray-400"
                 :aria-hidden true}
                [:span.sr-only
                 "Search"]]]]]
          [:nav.flex-1.min-h-0.overflow-y-auto
           {:aria-label (tr :directory)}
           (doall
            (for [[letter staffs-group] (->> (group-by #(first (:lastName %)) staffs)
                                             (sort-by first))]
              [:div.relative
               {:key letter}
               [:div.z-10.sticky.top-0.border-t.border-b.border-gray-200.bg-gray-50.px-6.py-1.text-sm.font-medium.text-gray-500
                [:h3 letter]]
               [:ul.relative.z-0.divide-y.divide-gray-200
                {:role "list"}
                (doall
                 (for [staff staffs-group
                       :let [is-active? (= (:id staff) (:id @selected-staff))]]
                   [:li
                    {:key (:id staff)
                     :on-click #(reset! selected-staff staff)}
                    [:div.relative.px-6.py-5.flex.items-center.space-x-3.hover:bg-gray-50.focus-within:ring-2.focus-within:ring-inset.focus-within:ring-primary-500
                     [:div.flex-shrink-0
                      [profile-img
                       {:class (cs "h-10 w-10 text-sm"
                                   (when (> (count (:lastNameJp staff)) 2)
                                     "text-xs")
                                   (if is-active?
                                     "text-primary-500"
                                     "text-gray-900"))
                        :text (if (or (blank? (:lastNameJp staff))
                                      (> (count (:lastNameJp staff)) 3))
                                (str (first (:firstName staff))
                                     (first (:lastName staff)))
                                (subs (:lastNameJp staff) 0 3))
                        :src (:profile_picture_url staff)
                        :alt (:name staff)}]]
                     [:div.flex-1.min-w-0.w-32
                      [:a.focus:outline-none
                       [:span.absolute.inset-0
                        {:aria-hidden true}]
                       [:p.text-sm.font-medium
                        (display-user-fullname staff)]
                       [:p.text-sm.text-gray-500.truncate
                        (:titleId staff)]]]
                     (when (some? (:spaceId staff))
                       [:div.inline-flex.items-center
                        [:span.text-xs.rounded-full.bg-gray-500.text-white.px-2.truncate
                         (:nameJp (get (listen ::subs/spaces-by-id) (:spaceId staff)))]])
                     (when (= (:id (listen ::subs/userinfo)) (:id staff))
                       [:div.inline-flex.items-center
                        [:span.text-sm.rounded-full.bg-primary-500.text-white.px-2
                         "Me"]])]]))]]))]]]))))
